import { render, staticRenderFns } from "./BroadcastPending.vue?vue&type=template&id=4d5bbd90&scoped=true&"
import script from "./BroadcastPending.vue?vue&type=script&lang=js&"
export * from "./BroadcastPending.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastPending.vue?vue&type=style&index=0&id=4d5bbd90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5bbd90",
  null
  
)

export default component.exports